export enum HelperStatus {
  Error,
  Valid,
  Neutral,
  Warn,
  Trust,
  Inactive,
  Recruit,
}

export default HelperStatus;
